module.exports = __webpack_public_path__ + "static/media/muhammad_atiq.b520ca45.jpg";